/**
 * networking
 *
 * handles AJAX requests and errorhandling of networking
 */

function networking () {
	window.timeOutMs = 10000;
	window.timeOutResponseText = 'Connection time out, please try again later.';

	function handlePromiseXhrResponse (xhr, resolve, reject, sessionKey) {
		if (xhr.status >= 200 && xhr.status < 300) {
			if (sessionKey) {
				sessionStorage.setItem(sessionKey, xhr.responseText);
			}
			resolve(xhr);
		} else if (xhr.status == 401) {
			// access denied on ajax so reload the page to force login!
			document.location.reload(true);
		} else {
			console.log('ERROR', xhr);
			reject(xhr);
		}
	}

	window.AJAX = function (method, url, payload, timeout, sessionKey, extraHeaders) {
		if (window.resetTimeout) window.resetTimeout();
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.open(method, url);
			xhr.setRequestHeader('Content-Type', 'application/json');
			if (extraHeaders) {
				for (var i = 0; i < extraHeaders.length; i++) {
					xhr.setRequestHeader(extraHeaders[i].key, extraHeaders[i].value);
				}
			}
			xhr.timeout = timeout || timeOutMs;
			xhr.onload = () => {
				handlePromiseXhrResponse(xhr, resolve, reject, sessionKey);
			};
			xhr.onerror = () => {
				console.log('ERROR', method, url, xhr);
				reject(xhr);
			};
			xhr.ontimeout = () => {
				console.log('TIMEOUT', method, url, xhr);
				reject(xhr);
			};
			xhr.send(payload);
		});
	};

	window.GET = function (url, timeout) {
		return AJAX('GET', url, null, timeout);
	};

	window.GETCACHEDSESSION = function (url, key, timeout) {
		if (!key) key = url;
		const sessionValue = sessionStorage.getItem(key);
		if (sessionValue) {
			// fire the resolve with dummy xhr
			const xhr = {
				status: 200,
				responseText: sessionValue
			};
			return new Promise((resolve, reject) => {
				console.log('cached', key);
				resolve(xhr);
			});
		}
		return AJAX('GET', url, null, timeout, key);
	};

	window.POST = function (url, payload, timeout) {
		return POSTBARE(url, JSON.stringify(payload), timeout);
	};

	window.POSTBARE = function (url, payload, timeout) {
		return AJAX('POST', url, payload, timeout);
	};

	window.PUT = function (url, payload, timeout) {
		return AJAX('PUT', url, JSON.stringify(payload), timeout);
	};

	window.POSTPUTMONGO = function (url, payload, payloadkey, timeout) {
		if (payloadkey == null) {
			return POST(url, payload, timeout);
		}
		return PUT(url, payload, timeout);
	};

	window.DELETE = function (url, timeout) {
		return AJAX('DELETE', url, null, timeout);
	};

	window.trapError = function (xhr) {
		try {
			const obj = JSON.parse(xhr.responseText);
			if (obj.Message) {
				window.initToast(obj.Message, 'error');
			} else if (obj.ResponseStatus && obj.ResponseStatus.Message) {
				window.initToast(obj.ResponseStatus.Message, 'error');
			} else {
				window.initToast(`${xhr.status}<br/>${xhr.responseText}`, 'error');
			}
		} catch (e) {
			window.initToast(`${xhr.status == 0 ? 'Timeout' : xhr.status}<br/>${xhr.responseURL}<br/>${xhr.responseText}`, 'error');
		}
		toggleLoader(false);
	};
}
networking();
